import { Controller } from "@hotwired/stimulus";
import Cookies from "js-cookie";

const COOKIE_NAME = "admin_nav_collapsed";

export default class extends Controller {
  static targets = ["shortcut"];

  #mobile = window.matchMedia("(max-width: 767px)");

  connect() {
    this.updateShortcutText();
    this.toggle = document.getElementById("admin-nav-toggle");
    if (this.toggle) {
      this.toggle.addEventListener("change", this.saveCollapsedState);
    }
    this.element.addEventListener("click", this.closeNavOnMobileLink);
  }

  disconnect() {
    if (this.toggle) {
      this.toggle.removeEventListener("change", this.saveCollapsedState);
    }
    this.element.removeEventListener("click", this.closeNavOnMobileLink);
  }

  saveCollapsedState = () => {
    const value = this.toggle.checked ? "0" : "1";
    Cookies.set(COOKIE_NAME, value, { path: "/", expires: 365, sameSite: "Lax" });
  };

  // On mobile the side nav is a full-width overlay, so tapping a nav link must collapse it —
  // otherwise the destination renders with the nav covering the page. The open state is restored
  // from the admin_nav_collapsed cookie on the next full page load (data-turbo="false"), so we
  // check the toggle and dispatch change, letting saveCollapsedState persist the cookie.
  closeNavOnMobileLink = (event) => {
    if (!this.#mobile.matches) return;
    const link = event.target.closest(".admin-nav a[href]");
    if (!link || link.target === "_blank") return;
    if (this.toggle && !this.toggle.checked) {
      this.toggle.checked = true;
      this.toggle.dispatchEvent(new Event("change", { bubbles: true }));
    }
  };

  updateShortcutText() {
    if (!this.hasShortcutTarget) return;

    const isMac = /Mac/.test(navigator.userAgent);
    if (!isMac) {
      this.shortcutTarget.textContent = "Ctrl + K";
    }
  }
}
